import { routes as live } from './live/';

export { live };



// WEBPACK FOOTER //
// ./src/views/routes.js